import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import APP_ROUTES from "../../../../routers/routeConstants";

import GinoHeader from "../../components/GinoHeader";
import { GinoMessage } from "../../components/Messages";
import { useGetMessages } from "../../api/queries/useGetMessages";
import { useGetGinoCredits } from "../../api/queries/ginoCredits";

const GinoChatHistoryPage = () => {
  const navigate = useNavigate();
  const { chatId } = useParams();

  useEffect(() => {
    if (!chatId) {
      navigate(APP_ROUTES.GINO_CHAT_HISTORY);
    }
  }, [chatId]);

  const { data: messages, isLoading: isLoadingMessages } = useGetMessages(chatId!);

  const [openCreditLeftModal, setOpenCreditLeftModal] = useState(false);
  const handleOpenCreditLeftModal = () => setOpenCreditLeftModal(true);
  const handleCloseCreditLeftModal = () => setOpenCreditLeftModal(false);

  const { data: ginoCredits, isLoading: isLoadingGinoCredits, error: errorGinoCredits } = useGetGinoCredits();

  return (
    <Box sx={styles.container}>
      <GinoHeader
        ginoCredits={ginoCredits}
        isLoadingGinoCredits={isLoadingGinoCredits}
        errorGinoCredits={errorGinoCredits}
        openCreditLeftModal={openCreditLeftModal}
        handleOpenCreditLeftModal={handleOpenCreditLeftModal}
        handleCloseCreditLeftModal={handleCloseCreditLeftModal}
      />
      <Box sx={styles.mainContainer}>
        <Box sx={styles.messagesContainer}>
          {messages?.map((message) => (
            <GinoMessage key={message.id} message={message} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default GinoChatHistoryPage;

const styles = {
  container: {
    width: "100%",
    height: "90vh",
    background: "var(--background-surface-default, #FFF)",
    padding: { xs: "16px", md: "32px" },
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    overflow: "hidden",
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    padding: { xs: "0", md: "0 80px" },
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
  },
  messagesContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    flex: 1,
    overflow: "auto",
    paddingRight: "12px",
  },
};
